
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_pcgz5_1teuo_25",
  "slider": "awsui_slider_pcgz5_1teuo_62",
  "slider-track": "awsui_slider-track_pcgz5_1teuo_66",
  "slider-range": "awsui_slider-range_pcgz5_1teuo_66",
  "disabled": "awsui_disabled_pcgz5_1teuo_81",
  "readonly": "awsui_readonly_pcgz5_1teuo_85",
  "error": "awsui_error_pcgz5_1teuo_94",
  "warning": "awsui_warning_pcgz5_1teuo_97",
  "active": "awsui_active_pcgz5_1teuo_100",
  "error-active": "awsui_error-active_pcgz5_1teuo_103",
  "warning-active": "awsui_warning-active_pcgz5_1teuo_106",
  "labels": "awsui_labels_pcgz5_1teuo_117",
  "labels-noref": "awsui_labels-noref_pcgz5_1teuo_123",
  "labels-reference": "awsui_labels-reference_pcgz5_1teuo_126",
  "labels-min": "awsui_labels-min_pcgz5_1teuo_133",
  "labels-max": "awsui_labels-max_pcgz5_1teuo_139",
  "labels-aria-description": "awsui_labels-aria-description_pcgz5_1teuo_147",
  "ticks": "awsui_ticks_pcgz5_1teuo_165",
  "ticks-wrapper": "awsui_ticks-wrapper_pcgz5_1teuo_171",
  "tick": "awsui_tick_pcgz5_1teuo_165",
  "middle": "awsui_middle_pcgz5_1teuo_186",
  "filled": "awsui_filled_pcgz5_1teuo_189",
  "tooltip-thumb": "awsui_tooltip-thumb_pcgz5_1teuo_217",
  "thumb": "awsui_thumb_pcgz5_1teuo_230",
  "min": "awsui_min_pcgz5_1teuo_268",
  "max": "awsui_max_pcgz5_1teuo_271"
};
  